import { render, staticRenderFns } from "./PhotosFolder.vue?vue&type=template&id=224597aa&scoped=true"
import script from "./PhotosFolder.vue?vue&type=script&lang=js"
export * from "./PhotosFolder.vue?vue&type=script&lang=js"
import style0 from "./PhotosFolder.vue?vue&type=style&index=0&id=224597aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224597aa",
  null
  
)

export default component.exports